import { Link } from "react-router-dom";

/* Kompass — vintage flight chart. Cream paper, oxblood ink, isobar lines. */
const P = {
  bg: "#F5EFE0",       // aged paper
  panel: "#FBF7EB",
  ink: "#1A1A18",
  inkDim: "#6F6A5E",
  ox: "#8C2E1F",       // oxblood / red ink
  oxLite: "#C4604E",
  forest: "#2D4032",
  line: "#D6CDB4",
};
const D = "'Fraunces', serif";
const S = "'IBM Plex Sans', system-ui, sans-serif";
const M = "'IBM Plex Mono', monospace";

export default function MockupKompass() {
  return (
    <div style={{ background: P.bg, color: P.ink, fontFamily: S, minHeight: "100vh", backgroundImage: `repeating-linear-gradient(0deg, transparent 0 39px, ${P.line}44 39px 40px)` }}>
      <div style={{ position: "sticky", top: 0, zIndex: 20, background: "rgba(245,239,224,0.95)", backdropFilter: "blur(10px)", borderBottom: `1px solid ${P.line}` }}>
        <div style={{ maxWidth: 1180, margin: "0 auto", padding: "14px 28px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Link to="/mockups" style={{ fontFamily: M, fontSize: 10, color: P.inkDim, textDecoration: "none", letterSpacing: "0.2em" }}>← ALLE RETNINGER</Link>
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <CompassRose size={22} />
            <span style={{ fontFamily: D, fontSize: 26, fontWeight: 500, letterSpacing: "-0.01em" }}>Kompass</span>
          </span>
          <span style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.25em", color: P.ox }}>VAR 04D — NAVIGASJON</span>
        </div>
      </div>

      <section style={{ maxWidth: 1180, margin: "0 auto", padding: "0 28px 100px" }}>
        <div style={{ paddingTop: 64 }}>
          <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.ox, marginBottom: 18 }}>01 · LANDING</div>
          <div style={{ background: P.panel, border: `1px solid ${P.line}`, position: "relative", overflow: "hidden" }}>
            {/* topographic background */}
            <svg style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0.25, pointerEvents: "none" }} viewBox="0 0 1100 800" preserveAspectRatio="xMidYMid slice">
              {[0,1,2,3,4,5].map((i) => (
                <path key={i} d={`M 0 ${300 + i*40} Q ${300 + i*30} ${100 + i*30} ${600} ${300 + i*40} T 1100 ${300 + i*40}`} stroke={P.ox} strokeWidth="0.6" fill="none" />
              ))}
            </svg>

            <nav style={{ padding: "24px 48px", borderBottom: `1px solid ${P.line}`, display: "flex", justifyContent: "space-between", alignItems: "center", position: "relative" }}>
              <span style={{ display: "flex", alignItems: "center", gap: 10 }}><CompassRose /><span style={{ fontFamily: D, fontSize: 28, fontWeight: 500 }}>Kompass</span></span>
              <div style={{ display: "flex", gap: 32, fontFamily: M, fontSize: 10, letterSpacing: "0.25em", color: P.inkDim }}>
                <span>KARTET</span><span>RUTER</span><span>JOURNALEN</span><span>MEDLEMSKAP</span>
              </div>
              <span style={{ fontFamily: M, fontSize: 10, color: P.ox, letterSpacing: "0.25em", borderBottom: `1px solid ${P.ox}`, paddingBottom: 2 }}>LOGG INN ↗</span>
            </nav>

            <div style={{ display: "grid", gridTemplateColumns: "1.1fr 1fr", padding: "64px 48px", gap: 48, alignItems: "center", position: "relative" }}>
              <div>
                <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.35em", color: P.ox, marginBottom: 28 }}>59°54′N · 10°44′Ø — OSLO</div>
                <h1 style={{ fontFamily: D, fontSize: "clamp(56px, 7vw, 100px)", fontWeight: 400, letterSpacing: "-0.03em", lineHeight: 0.95, margin: 0 }}>
                  Kartlegg <em style={{ fontStyle: "italic", color: P.ox }}>hver kjøp.</em><br />Naviger til <em style={{ fontStyle: "italic", color: P.ox }}>flere reiser.</em>
                </h1>
                <p style={{ marginTop: 30, fontSize: 16, lineHeight: 1.75, color: P.ink, maxWidth: 480, fontFamily: D, fontStyle: "italic", fontWeight: 400 }}>
                  «Et kompass for den moderne norske poengjegeren — som måler avstanden fra hver krone til neste reisemål.»
                </p>
                <p style={{ marginTop: 18, fontSize: 14, color: P.inkDim, lineHeight: 1.7, maxWidth: 480 }}>
                  Kompass kartlegger hver butikk du besøker, leser sjøkartet over EuroBonus-poeng og Trumf-cashback, og plotter den raskeste ruten til din neste reise.
                </p>
                <div style={{ marginTop: 36, display: "flex", gap: 14, alignItems: "center" }}>
                  <button style={{ background: P.ox, color: P.panel, border: "none", padding: "16px 28px", fontFamily: M, fontWeight: 600, fontSize: 12, letterSpacing: "0.2em", cursor: "pointer" }}>SETT KURSEN →</button>
                  <span style={{ fontFamily: M, fontSize: 11, color: P.inkDim, letterSpacing: "0.15em" }}>14 DAGER FRI · 15 KR/MND</span>
                </div>
              </div>

              {/* Stamped journal entry */}
              <div style={{ position: "relative", background: P.panel, padding: 32, transform: "rotate(-1deg)", border: `1px solid ${P.line}`, boxShadow: "4px 6px 0 rgba(26,26,24,0.06)" }}>
                <div style={{ position: "absolute", top: 16, right: 16, padding: "8px 14px", border: `2px solid ${P.ox}`, color: P.ox, fontFamily: M, fontSize: 11, letterSpacing: "0.25em", fontWeight: 600, transform: "rotate(8deg)", opacity: 0.85 }}>VERIFISERT</div>
                <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.inkDim }}>JOURNAL — OPPFØRING NR. 47</div>
                <div style={{ fontFamily: D, fontSize: 32, fontWeight: 500, marginTop: 8, letterSpacing: "-0.01em" }}>Komplett</div>
                <div style={{ fontFamily: M, fontSize: 10, color: P.inkDim, letterSpacing: "0.15em" }}>komplett.no — 14.06.2026</div>

                <div style={{ marginTop: 24, paddingTop: 18, borderTop: `1px solid ${P.line}` }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
                    <div>
                      <div style={{ fontFamily: M, fontSize: 9, letterSpacing: "0.25em", color: P.inkDim }}>EUROBONUS</div>
                      <div style={{ fontFamily: D, fontSize: 36, fontWeight: 500, color: P.ox, lineHeight: 1, marginTop: 4 }}>+15 p</div>
                      <div style={{ fontFamily: M, fontSize: 10, color: P.inkDim, letterSpacing: "0.1em", marginTop: 4 }}>per 100 kr</div>
                    </div>
                    <div>
                      <div style={{ fontFamily: M, fontSize: 9, letterSpacing: "0.25em", color: P.inkDim }}>AVSTAND</div>
                      <div style={{ fontFamily: D, fontSize: 36, fontWeight: 500, color: P.forest, lineHeight: 1, marginTop: 4 }}>2 940 km</div>
                      <div style={{ fontFamily: M, fontSize: 10, color: P.inkDim, letterSpacing: "0.1em", marginTop: 4 }}>til CPH ⇢</div>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: 22, paddingTop: 14, borderTop: `1px dashed ${P.line}`, fontFamily: D, fontStyle: "italic", fontSize: 14, color: P.inkDim, lineHeight: 1.5 }}>
                  «Foretrukken rute: SAS EuroBonus + Diners Premium. 6 % effektiv avkastning på elektronikk.»
                </div>
              </div>
            </div>

            {/* Pricing bar */}
            <div style={{ padding: "48px 48px", borderTop: `1px solid ${P.line}`, background: P.bg, position: "relative", display: "grid", gridTemplateColumns: "1fr auto", gap: 48, alignItems: "center" }}>
              <div>
                <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.ox, marginBottom: 12 }}>MEDLEMSKAP — UTEN BINDING</div>
                <div style={{ fontFamily: D, fontSize: 48, fontWeight: 400, letterSpacing: "-0.02em" }}>
                  Femten kroner. <em style={{ fontStyle: "italic", color: P.ox }}>Uendelig nye ruter.</em>
                </div>
              </div>
              <button style={{ background: P.ink, color: P.panel, border: "none", padding: "18px 28px", fontFamily: M, fontWeight: 600, fontSize: 12, letterSpacing: "0.25em", cursor: "pointer" }}>ÅPNE JOURNALEN →</button>
            </div>
          </div>
        </div>

        <div style={{ paddingTop: 64 }}>
          <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.ox, marginBottom: 18 }}>02 · EXTENSION POPUP</div>
          <div style={{ padding: "60px 0", background: P.bg, display: "flex", justifyContent: "center", border: `1px solid ${P.line}`, position: "relative", overflow: "hidden" }}>
            <svg style={{ position: "absolute", inset: 0, opacity: 0.2 }} width="100%" height="100%" viewBox="0 0 1100 400" preserveAspectRatio="xMidYMid slice">
              {[0,1,2,3].map((i) => (<circle key={i} cx="550" cy="200" r={80 + i*60} stroke={P.ox} strokeWidth="0.6" fill="none" strokeDasharray="2 6" />))}
            </svg>
            <div style={{ width: 360, background: P.panel, border: `1px solid ${P.line}`, fontFamily: S, position: "relative", boxShadow: "4px 6px 0 rgba(26,26,24,0.08)" }}>
              <div style={{ padding: "14px 20px", borderBottom: `1px solid ${P.line}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ display: "flex", alignItems: "center", gap: 8 }}><CompassRose size={16} /><span style={{ fontFamily: D, fontSize: 20, fontWeight: 500 }}>Kompass</span></span>
                <span style={{ fontFamily: M, fontSize: 10, color: P.inkDim, letterSpacing: "0.15em" }}>↻</span>
              </div>
              <div style={{ padding: "18px 20px 8px" }}>
                <div style={{ fontFamily: M, fontSize: 9, letterSpacing: "0.3em", color: P.inkDim }}>POSISJON</div>
                <div style={{ fontFamily: D, fontSize: 24, fontWeight: 500, marginTop: 4 }}>komplett.no</div>
                <div style={{ marginTop: 4, fontFamily: M, fontSize: 10, color: P.ox, letterSpacing: "0.15em" }}>59°54′N · 10°44′Ø</div>
              </div>
              <div style={{ margin: "0 20px 12px", padding: "14px 16px", border: `1px solid ${P.ox}`, position: "relative" }}>
                <div style={{ position: "absolute", top: -10, left: 16, padding: "2px 10px", background: P.panel, fontFamily: M, fontSize: 9, letterSpacing: "0.25em", color: P.ox }}>SJEKKPUNKT</div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginTop: 6 }}>
                  <div>
                    <div style={{ fontFamily: D, fontSize: 40, fontWeight: 500, color: P.ox, lineHeight: 1 }}>+15 p</div>
                    <div style={{ fontFamily: M, fontSize: 10, color: P.inkDim, marginTop: 4, letterSpacing: "0.15em" }}>EUROBONUS / 100 KR</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ fontFamily: M, fontSize: 9, color: P.inkDim, letterSpacing: "0.2em" }}>KURS</div>
                    <div style={{ fontFamily: D, fontSize: 18, fontWeight: 500 }}>↗ CPH</div>
                  </div>
                </div>
              </div>
              <div style={{ padding: "0 20px 12px" }}>
                <div style={{ fontFamily: M, fontSize: 9, letterSpacing: "0.25em", color: P.inkDim, marginBottom: 8 }}>NAVIGASJONSMETODER</div>
                {["Visa","Mastercard","Vipps","Klarna"].map((m) => (
                  <div key={m} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px dashed ${P.line}`, fontSize: 13 }}>
                    <span style={{ fontFamily: D, fontWeight: 500 }}>{m}</span>
                    <span style={{ fontFamily: M, fontSize: 10, color: P.forest, letterSpacing: "0.15em" }}>● TRYGG</span>
                  </div>
                ))}
              </div>
              <div style={{ padding: "10px 20px 14px", borderTop: `1px solid ${P.line}`, display: "flex", justifyContent: "space-between", fontFamily: M, fontSize: 10, letterSpacing: "0.2em", color: P.inkDim }}>
                <span>OPPFØRING NR. 47</span>
                <span><span style={{ color: P.ox }}>NO</span> / EN</span>
              </div>
            </div>
          </div>
        </div>

        <div style={{ paddingTop: 64 }}>
          <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.ox, marginBottom: 18 }}>03 · DASHBOARD</div>
          <div style={{ background: P.panel, border: `1px solid ${P.line}` }}>
            <nav style={{ padding: "20px 36px", borderBottom: `1px solid ${P.line}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", gap: 40, alignItems: "center" }}>
                <span style={{ display: "flex", alignItems: "center", gap: 10 }}><CompassRose /><span style={{ fontFamily: D, fontSize: 24, fontWeight: 500 }}>Kompass</span></span>
                <div style={{ display: "flex", gap: 28, fontFamily: M, fontSize: 11, letterSpacing: "0.18em" }}>
                  <span style={{ color: P.ox, borderBottom: `1px solid ${P.ox}`, paddingBottom: 4 }}>KARTET</span>
                  <span style={{ color: P.inkDim }}>JOURNALEN</span>
                  <span style={{ color: P.inkDim }}>RUTER</span>
                </div>
              </div>
              <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
                <span style={{ fontFamily: M, fontSize: 10, color: P.inkDim, letterSpacing: "0.2em" }}>NO / EN</span>
                <span style={{ width: 32, height: 32, background: P.ox, color: P.panel, display: "grid", placeItems: "center", fontFamily: D, fontWeight: 500 }}>S</span>
              </div>
            </nav>

            <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr", borderBottom: `1px solid ${P.line}` }}>
              <div style={{ padding: "44px 36px", borderRight: `1px solid ${P.line}`, position: "relative", overflow: "hidden" }}>
                <svg style={{ position: "absolute", inset: 0, opacity: 0.18 }} width="100%" height="100%" viewBox="0 0 600 400" preserveAspectRatio="xMidYMid slice">
                  {[0,1,2,3,4].map((i) => (<path key={i} d={`M 0 ${100 + i*60} Q 200 ${50 + i*40} 400 ${100 + i*60} T 800 ${100 + i*60}`} stroke={P.ox} strokeWidth="0.7" fill="none" />))}
                </svg>
                <div style={{ position: "relative" }}>
                  <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.inkDim, marginBottom: 18 }}>JUNI MMXXVI · DEN OPPDAGEDE STREKNINGEN</div>
                  <div style={{ fontFamily: D, fontSize: 120, fontWeight: 400, lineHeight: 0.9, letterSpacing: "-0.05em", color: P.ox }}>12 480</div>
                  <div style={{ fontFamily: D, fontSize: 22, fontWeight: 400, fontStyle: "italic", marginTop: 8 }}>poeng — eller 2 940 km nordover.</div>
                  <div style={{ marginTop: 28, fontFamily: M, fontSize: 11, color: P.inkDim, letterSpacing: "0.15em", display: "flex", gap: 24 }}>
                    <span>↑ 22 % MAI</span><span>≈ 1 248 KR</span><span>17 OPPFØRINGER</span>
                  </div>
                </div>
              </div>
              <div style={{ padding: "32px 36px", background: P.bg }}>
                <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.inkDim, marginBottom: 18 }}>FREMDRIFT — NESTE HAVNER</div>
                {[["OSL → CPH", "10 000 p", 100, true], ["OSL → AMS", "20 000 p", 62, false], ["OSL → JFK", "40 000 p", 31, false]].map(([r, p, w, ok]) => (
                  <div key={r} style={{ paddingBottom: 14, marginBottom: 14, borderBottom: `1px dashed ${P.line}` }}>
                    <div style={{ display: "flex", justifyContent: "space-between", fontFamily: M, fontSize: 11, letterSpacing: "0.15em", color: P.inkDim, marginBottom: 8 }}>
                      <span style={{ color: ok ? P.forest : P.ink }}>{ok ? "● " : ""}{r}</span><span>{p}</span>
                    </div>
                    <div style={{ height: 6, background: P.line, position: "relative" }}>
                      <div style={{ position: "absolute", left: 0, top: 0, height: "100%", width: `${w}%`, background: ok ? P.forest : P.ox }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ padding: "32px 36px" }}>
              <div style={{ fontFamily: D, fontSize: 28, fontWeight: 500, marginBottom: 16, letterSpacing: "-0.01em" }}>Journalen — siste oppføringer</div>
              <div style={{ border: `1px solid ${P.line}` }}>
                <div style={{ display: "grid", gridTemplateColumns: "60px 1.2fr 1.4fr 1fr 80px", padding: "10px 22px", background: P.bg, fontFamily: M, fontSize: 9, letterSpacing: "0.25em", color: P.inkDim, borderBottom: `1px solid ${P.line}` }}>
                  <span>NR.</span><span>FORHANDLER</span><span>OPPTJENING</span><span>RUTE</span><span style={{ textAlign: "right" }}>DATO</span>
                </div>
                {[
                  ["47","Komplett","komplett.no","+225 EuroBonus","↗ CPH","14.06"],
                  ["46","Meny","meny.no","+3% Trumf · 84 kr","↗ Lokal","12.06"],
                  ["45","XXL Sport","xxl.no","+120 EuroBonus","↗ AMS","09.06"],
                  ["44","Hotels.com","hotels.com","+820 EuroBonus","↗ JFK","02.06"],
                ].map(([nr,n,h,e,r,d]) => (
                  <div key={nr} style={{ display: "grid", gridTemplateColumns: "60px 1.2fr 1.4fr 1fr 80px", padding: "16px 22px", borderTop: `1px solid ${P.line}`, alignItems: "center", fontSize: 13 }}>
                    <span style={{ fontFamily: M, fontSize: 11, color: P.ox, letterSpacing: "0.15em" }}>{nr}</span>
                    <div><div style={{ fontFamily: D, fontSize: 17, fontWeight: 500 }}>{n}</div><div style={{ fontFamily: M, fontSize: 10, color: P.inkDim, letterSpacing: "0.1em" }}>{h}</div></div>
                    <div style={{ fontFamily: M, fontSize: 11, color: P.ox, letterSpacing: "0.08em" }}>{e}</div>
                    <div style={{ fontFamily: M, fontSize: 11, color: P.forest, letterSpacing: "0.1em" }}>{r}</div>
                    <div style={{ fontFamily: M, fontSize: 11, color: P.inkDim, textAlign: "right", letterSpacing: "0.1em" }}>{d}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function CompassRose({ size = 22 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" stroke="#1A1A18" strokeWidth="1.2">
      <circle cx="16" cy="16" r="13" />
      <path d="M16 4 L18 16 L16 28 L14 16 Z" fill="#8C2E1F" stroke="#8C2E1F" />
      <path d="M4 16 L16 14 L28 16 L16 18 Z" />
      <circle cx="16" cy="16" r="1.6" fill="#1A1A18" />
    </svg>
  );
}
